/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface AnswerOption
 */
export interface AnswerOption {
  /**
   *
   * @type {number}
   * @memberof AnswerOption
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof AnswerOption
   */
  label: string;
  /**
   *
   * @type {string}
   * @memberof AnswerOption
   */
  inputType: string;
  /**
   *
   * @type {number}
   * @memberof AnswerOption
   */
  order?: number;
}

/**
 * Check if a given object implements the AnswerOption interface.
 */
export function instanceOfAnswerOption(value: object): value is AnswerOption {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('label' in value) || value['label'] === undefined) return false;
  if (!('inputType' in value) || value['inputType'] === undefined) return false;
  return true;
}

export function AnswerOptionFromJSON(json: any): AnswerOption {
  return AnswerOptionFromJSONTyped(json, false);
}

export function AnswerOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnswerOption {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    label: json['label'],
    inputType: json['input_type'],
    order: json['order'] == null ? undefined : json['order'],
  };
}

export function AnswerOptionToJSON(value?: Omit<AnswerOption, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    label: value['label'],
    input_type: value['inputType'],
    order: value['order'],
  };
}
